import { maskCurrencyInput } from '@/lib/mask'
import { priceFieldsMapper } from '@/utils/transformers/filters/prices'

export default {
  name: 'oz-prices',

  props: {
    min: { type: [String, Number], default: '' },
    max: { type: [String, Number], default: '' },
    rentTotalPrice: { type: Boolean },
    isCondoPrice: { type: Boolean },
  },

  data () {
    return {
      priceMin: '',
      priceMax: '',
      invalidInputMessage: 'Preço máximo deve ser maior que preço mínimo',
    }
  },

  created () {
    this.priceMin = this.min ? this.min.toString() : ''
    this.priceMax = this.max ? this.max.toString() : ''
  },

  watch: {
    min () {
      this.priceMin = this.min ? this.min.toString() : ''
    },

    max () {
      this.priceMax = this.max ? this.max.toString() : ''
    },
  },

  computed: {
    label () {
      return this.isCondoPrice ? 'Preço do condomínio' : 'Preço'
    },

    placeholderMin () {
      return 'R$ 0'
    },

    placeholderMax () {
      return 'R$ 1 tri'
    },

    minValueMasked: maskCurrencyInput('priceMin'),
    maxValueMasked: maskCurrencyInput('priceMax'),

    isInvalid () {
      if (!this.priceMax || !this.priceMin) return false
      return Number(this.priceMax) < Number(this.priceMin)
    },
  },

  methods: {
    onInputPriceMin (inputedValue) {
      inputedValue = this.removeMask(inputedValue)
      this.priceMin = inputedValue.toString()
    },

    onInputPriceMax (inputedValue) {
      inputedValue = this.removeMask(inputedValue)
      this.priceMax = inputedValue.toString()
    },

    onBlur (value, field) {
      if (Number(this[field]) !== Number(value.replaceAll('.', '')) && !this.isInvalid) {
        this.updateFilter()
      }
    },

    removeMask (valueMasked) {
      return valueMasked.split('.').join('')
    },

    updateFilter () {
      const { priceMin: min, priceMax: max } = this

      const condoFields = { priceMinCondo: max ? (min || '1') : min, priceMaxCondo: max }

      const prices = this.isCondoPrice
        ? condoFields
        : priceFieldsMapper(this.rentTotalPrice, { min, max })

      this.$emit('filters:update', prices)
    },
  },
}
